export enum ZendeskOrigin {
  Login = 'login',
  InApp = 'inApp',
  Loading = 'loading',
}

export const ZENDESK_FIELDS = {
  formId: 37082421432466,

  username: '37091588565906',
  usernameHidden: '37091582437394',

  userId: '37083494258834',
  userIdHidden: '37090979537170',

  shopLevel: '37086196708370',
  buys: '37086157531794',
  email: '37091004349074',

  date: '32748875592722',

  logged: '37092029164562',
  loading: '36264276428946',

  wallet: '37091949409938',
  deviceType: '17651189235346',
} as const;
